// this is bad because we're managing state outside of redux, but we have to work with the vp.widget code for now until we build our own loader
let _loadingBoxShown = false;

export default class VistaprintWidgetUtil {
    static get loadingBoxShown() {
        return _loadingBoxShown;
    }
    static showLoadingBox(message) {
        if (window.vp) {
            window.vp.widget.showLoadingBox(message);
            _loadingBoxShown = true;
        }
    }

    static hideLoadingBox() {
        window.vp.widget.hideLoadingBox();
        _loadingBoxShown = false;
    }
}



// WEBPACK FOOTER //
// ./src/utils/VistaprintWidgetUtil.js